<template>
  <div class="registercss">
    <el-row type="flex"
            style="height: 100%;"
            align="middle"
            justify="center">
      <div style="height: 500px;box-shadow:0 0 15px rgba(236,249,247,0.2);overflow: hidden;">
        <div style="display:inline-block;height: 100%;border-radius:15px;">
          <img style="height:100%;"
               src="../../public/img/login_left.png" />
        </div>
        <div style="display:inline-block;height: 100%;position: relative;border-radius:15px;">
          <img style="height:100%;"
               src="../../public/img/login_right.png" />
          <div style="position: absolute;top:0;left:0;width:100%;height: 100%;"
               v-loading="loading">
            <div class="register-box">
              <div style="display:flex;align-items:flex-end;justify-content:flex-start;border-bottom:1px solid #eaeaea;">
                <div class="tab-bar-item">欢迎注册</div>
              </div>
              <div class="input-form">
                <el-form ref="userInfo"
                         class="myform"
                         :model="userInfo"
                         :rules="formRules">
                  <el-form-item prop="phone">
                    <el-input v-model="userInfo.phone"
                              @keyup.enter.native="$refs.username.focus()"
                              placeholder="请输入您的手机号码">
                      <i slot="prefix"
                         class="iconfont icon-shouji-m"></i>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="username">
                    <el-input v-model="userInfo.username"
                              ref="username"
                              @keyup.enter.native="$refs.email.focus()"
                              placeholder="请输入您的姓名">
                      <i slot="prefix"
                         class="iconfont icon-yonghu"></i>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="email">
                    <el-input v-model="userInfo.email"
                              ref="email"
                              @keyup.enter.native="$refs[companyDisabled?'pass':'company'].focus()"
                              placeholder="请输入您的邮箱地址">
                      <i slot="prefix"
                         class="iconfont icon-youxiang"></i>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="company">
                    <el-input v-model="userInfo.company"
                              ref="company"
                              @keyup.enter.native="$refs.pass.focus()"
                              :disabled="companyDisabled"
                              placeholder="请输入您的公司名称">
                      <i slot="prefix"
                         class="iconfont icon-gongsi"></i>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input v-model="userInfo.password"
                              show-password
                              ref="pass"
                              @keyup.enter.native="submitForm()"
                              auto-complete="new-password"
                              placeholder="请设置您的登录密码">
                      <i slot="prefix"
                         class="iconfont icon-lock-full"></i>
                    </el-input>
                  </el-form-item>
                  <el-form-item style="margin-bottom:0px;margin-top:-10px;">
                    <el-checkbox v-model="agreement"></el-checkbox>
                    <div style="display:inline-block;margin-left:6px;">同意并遵守<a target="_blank"
                         rel="noopener noreferrer"
                         href="https://datainside.com.cn/protocol/"
                         class="link">{{'《用户协议》'}}</a>和<a target="_blank"
                         href="https://datainside.com.cn/yszc/"
                         rel="noopener noreferrer"
                         class="link">{{'《隐私政策》'}}</a></div>
                  </el-form-item>
                  <el-form-item style="margin-bottom:10px;">
                    <el-button type="primary"
                               :disabled="canRegister"
                               style="width:100%;margin-top:0px;"
                               @click="submitForm()">注册</el-button>
                  </el-form-item>
                </el-form>
                <div @click="toLogin"
                     class="text-btn">已有账号，立即登录</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'register',
  data () {
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else if (!(/^1(2|3|4|5|6|7|8|9)\d{9}$/.test(value))) {
        callback(new Error('请输入正确的11位手机号'));
      } else {
        callback();
      }
    };
    var validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'));
      }
      let yz = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]])[A-Za-z\d`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]{8,20}$/;
      if (!yz.exec(value)) {
        callback(new Error('密码必须为8-20位数字+字母+特殊字符的组合'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      wxOpenid: '',//用户的微信id
      uid: '',//分享人的id
      companyDisabled: false,//为true时表示被邀请注册
      userInfo: {
        username: '',
        phone: '',
        email: '',
        password: '',
        company: ''
      },
      formRules: {
        username: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        },
        {
          min: 2,
          max: 18,
          message: '长度在 2 到 18 个字符',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        },
        {
          validator: validatePhone,
          trigger: 'blur'
        }
        ],
        email: [{
          type: 'email',
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        },
        {
          min: 2,
          max: 40,
          message: '长度在 2 到 40 个字符',
          trigger: 'blur'
        }],
        company: [{
          required: true,
          message: '请输入您的单位名称',
          trigger: 'blur'
        },
        {
          min: 2,
          max: 18,
          message: '长度在 2 到 30 个字符',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请设置登录密码',
          trigger: 'blur'
        },
        {
          validator: validatePassword,
          trigger: 'blur'
        }
        ]
      },
      agreement: false,
    }
  },
  computed: {
    canRegister () {
      if (this.userInfo.phone && this.userInfo.username && this.userInfo.password && this.userInfo.email && this.userInfo.company) {
        return false;
      } else {
        return true;
      }
    },
  },
  created () {
    let param = this.$route.query;
    if (param && param.wxid) {
      //首次扫码注册信息
      this.wxOpenid = param.wxid;
    }
    if (param && param.uid) {
      //首次扫码注册信息
      this.uid = param.uid;
    }
    if (param && param.p) {
      //分享链接注册
      let p = JSON.parse(this.$aes.decrypt(decodeURIComponent(param.p)));
      this.uid = p.userid;
      this.userInfo.company = p.company;
      this.companyDisabled = true;
    }
  },
  methods: {
    toLogin () {
      this.$router.push('/wxlogin');
    },
    submitForm () {
      this.$refs.userInfo.validate((valid) => {
        if (valid) {
          if (this.agreement) {
            this.submitUserInfo();
          } else {
            this.$message.info('请阅读并同意《用户协议》和《隐私政策》！');
            return false;
          }
        } else {
          return false;
        }
      });
    },
    submitUserInfo () {
      this.loading = true;
      let param = {
        username: this.$aes.encrypt(this.userInfo.username),
        phone: this.$aes.encrypt(this.userInfo.phone),
        email: this.$aes.encrypt(this.userInfo.email),
        password: this.$aes.encrypt(this.userInfo.password),
        company: this.$aes.encrypt(this.userInfo.company),
        openid: this.$aes.encrypt(this.wxOpenid),
        recommenduid: this.$aes.encrypt(this.uid)
      };
      this.$request.post('api/Platform/IntegrationUserAuth/addUser/', param).then((response) => {
        this.loading = false;
        if (response.code === '000000') {
          this.openBIUrl(response.data.links);
        } else {
          this.$message.error(response.message);
        }
      })
        .catch((e) => {
          this.loading = false;
          this.$message.error("连接失败！请重试！");
        });
    },
    openBIUrl (links) {
      if (links && links.length > 0) {
        window.location.href = links[0].url;
      } else {
        alert('没有可使用的系统!');
      }
    }
  }
}
</script>

<style lang="scss">
a.link {
  text-decoration: none;
}
a.link,
a.link:hover {
  color: #42c3af;
}
a.link:hover {
  text-decoration: underline;
}
.text-btn {
  text-align: center;
  margin-top: 0px;
  font-size: 13px;
  color: #42c3af;
  cursor: pointer;
}
.text-btn:hover {
  text-decoration: underline;
}

.registercss {
  width: 100%;
  height: 100%;
  min-width: 960px;
  min-height: 550px;
  background-image: url(../../public/img/loginbg.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .input-form {
    padding: 20px 20px;
    .myform .el-input__inner {
      letter-spacing: 1px;
      font-size: 14px;
      padding-left: 45px;
      padding-right: 20px;
      border-radius: 25px;
      background-color: #F7F8FA;
    }
    .myform .el-input__prefix {
      left: 20px;
    }
    .myform .el-button {
      border-radius: 25px;
    }
    .myform .el-form-item__error {
      left: 35px;
    }
  }
  .tab-bar-item {
    line-height: 50px;
    font-size: 18px;
    color: #333;
  }

  .register-box {
    text-align: center;
    padding: 0px 40px;
  }
}
</style>
